import { QueryValidator, ValidationMap } from "react-querybuilder";
import {
  PowersearchFieldEnum,
  PowersearchFieldTitles,
} from "./PowersearchQueryComponents/PowersearchQueryRule";
import isValidBooleanExpression from "../../../../utils/isValidBooleanExpression";

const powersearchRuleValidator: QueryValidator = (q): ValidationMap => {
  const finalValidations = {} as ValidationMap;

  if (q.rules.length === 0) {
    finalValidations[q.id as string] = {
      valid: false,
      reasons: ["Please add a search condition"],
    };
    return finalValidations;
  }

  q.rules.forEach((rule) => {
    if (typeof rule === "object" && "rules" in rule) {
      const nestedValidations = powersearchRuleValidator(rule);
      Object.assign(finalValidations, nestedValidations);
      return;
    }

    if (typeof rule === "string" || !("id" in rule) || !("field" in rule)) {
      return;
    }

    const value = (rule as any).value;

    switch (rule.field) {
      case PowersearchFieldEnum.CompanyHeadCountRange:
        if (isNaN(value) || value <= 0) {
          finalValidations[rule.id as string] = {
            valid: false,
            reasons: [
              `${PowersearchFieldTitles[PowersearchFieldEnum.CompanyHeadCountRange]} must be an integer greater than 0`,
            ],
          };
        }
        break;

      case PowersearchFieldEnum.CompanyCity:
      case PowersearchFieldEnum.ContactCity:
        if (!Array.isArray(value) || value.length === 0) {
          finalValidations[rule.id as string] = {
            valid: false,
            reasons: [
              `${PowersearchFieldTitles[rule.field as PowersearchFieldEnum]} must have at least one entry`,
            ],
          };
        }
        break;

      case PowersearchFieldEnum.JobTitle:
      case PowersearchFieldEnum.CompanyDescription:
      case PowersearchFieldEnum.LinkedInProfileKeywords:
        if (
          !value ||
          typeof value !== "string" ||
          !isValidBooleanExpression(value)
        ) {
          finalValidations[rule.id as string] = {
            valid: false,
            reasons: [
              `${PowersearchFieldTitles[rule.field as PowersearchFieldEnum]} must be a valid boolean expression string`,
            ],
          };
        }
        break;

      case PowersearchFieldEnum.ContactCountry:
      case PowersearchFieldEnum.CompanyCountryIso:
        if (!Array.isArray(value) || value.length === 0) {
          finalValidations[rule.id as string] = {
            valid: false,
            reasons: [
              `${PowersearchFieldTitles[rule.field as PowersearchFieldEnum]} must have at least one entry`,
            ],
          };
        }
        break;

      case PowersearchFieldEnum.ContactState:
      case PowersearchFieldEnum.CompanyState:
        if (!Array.isArray(value) || value.length === 0) {
          finalValidations[rule.id as string] = {
            valid: false,
            reasons: [
              `${PowersearchFieldTitles[rule.field as PowersearchFieldEnum]} must have at least one entry`,
            ],
          };
        }
        break;

      case PowersearchFieldEnum.CompanyIndustry:
        if (!Array.isArray(value) || value.length === 0) {
          finalValidations[rule.id as string] = {
            valid: false,
            reasons: [
              `${PowersearchFieldTitles[PowersearchFieldEnum.CompanyIndustry]} must have at least one entry`,
            ],
          };
        }
        break;

      default:
        finalValidations[rule.id as string] = {
          valid: false,
          reasons: ["Please select a valid field"],
        };
        break;
    }
  });

  return finalValidations;
};

export default powersearchRuleValidator;
